// extracted by mini-css-extract-plugin
export default {"wrapper":"np-z","response":"op-z","error":"pp-z","disabled":"qp-z","buttons":"rp-z","feedbackQuestionSection":"sp-z","yesNoWrapper":"tp-z"};